export default "__VITE_PUBLIC_ASSET__7c667cc2__"